import request from '@/utils/request'

// 获取应用列表
export const getAppList = (params) => request({
  url: '/bd/operation/getUserOperation',
  method: 'get',
  params
})
// 记录用户点击
export const logUserClick = (params) => request({
  url: '/bd/homepage/userOperation',
  method: 'post',
  params
})
// 获取系统参数
export const getSystemParam = (userId) => request({
  url: '/bd/user/getButtJointInfo',
  method: 'get',
  params: { userId }
})